import React, { useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import StripeSetupForm from '../../../../components/StripeSetupForm'

export default function SponsorPledgeStripeModal({
  show,
  onHide,
  onPaymentSuccess,
  submitting,
  paymentMethodType,
}) {
  const { t } = useTranslation()
  const [modalEntered, setModalEntered] = useState(false)

  useEffect(() => {
    if (!show) {
      setModalEntered(false)
    }
  }, [show])

  return (
    <Modal
      show={show}
      onHide={() => {
        if (!submitting) onHide()
      }}
      onEntered={() => setModalEntered(true)}
      onExited={() => setModalEntered(false)}
      centered
      size="lg"
    >
      <Modal.Header closeButton={!submitting}>
        <Modal.Title>
          {t('sponsorPledgeFlow.step5.paymentModalTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ position: 'relative' }}>
        {submitting ? (
          <div
            className="d-flex flex-column align-items-center justify-content-center py-5 gap-2"
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.85)',
              zIndex: 2,
            }}
          >
            <Spinner animation="border" />
            <span className="text-muted small">
              {t('sponsorPledgeFlow.step5.submittingPledge')}
            </span>
          </div>
        ) : null}
        {show && modalEntered ? (
          <StripeSetupForm
            key={paymentMethodType}
            paymentMethodType={paymentMethodType}
            onSuccess={onPaymentSuccess}
            onCancel={submitting ? undefined : onHide}
          />
        ) : show ? (
          <div className="stripe-setup-loading text-center py-4">
            <Spinner animation="border" className="mb-2" />
            <p>{t('sponsorship.pledgeModal.paymentStep.loading')}</p>
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  )
}
